import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';

export interface XimiDeviceContext {
    uuid: string;
    applicationversion: string;
    model: string;
    userAgent: string;
}

let cached: Promise<XimiDeviceContext> | null = null;

/** Contexte device (constant sur la session) — résolu une seule fois puis mémoïsé. */
export function getXimiDeviceContext(): Promise<XimiDeviceContext> {
    if (!cached) cached = resolveXimiDeviceContext();
    return cached;
}

async function resolveXimiDeviceContext(): Promise<XimiDeviceContext> {
    const { identifier } = await Device.getId();
    const info = await Device.getInfo();
    let applicationversion = '';
    try {
        applicationversion = (await App.getInfo()).version;
    } catch {
        applicationversion = ''; // App.getInfo non dispo sur web
    }
    return {
        uuid: identifier || 'unknown',
        applicationversion,
        model: `${info.model} ${info.manufacturer}`.trim(),
        userAgent: navigator.userAgent
    };
}
